//React
import React from 'react'
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myProofAction from '../action/myProofAction';
import * as lightboxAction from '../action/lightboxAction';
import * as uiAction from '../action/uiAction';
import * as guideAction from '../action/guideAction';
import * as helpAction from '../action/helpAction';
//Add
import { imageResize, imageRotate } from '../func/imageResizeRotate';
import { withAlert } from 'react-alert';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import Box from '@material-ui/core/Box';
//Icon
import ClearIcon from '@material-ui/icons/Clear';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CheckIcon from '@material-ui/icons/Check';
//image
import hnUnten from '../img/proof/hn-unten.jpg';
import hnUntenRotate from '../img/proof/hn-unten_rotate.png';
import hnHokensyou from '../img/proof/hn-hokensyou.jpg';
import hnMynumber from '../img/proof/hn-mynumber.png';
import hnPassport from '../img/proof/hn-passport.jpg';
import truste from '../img/truste/truste.png';

//Part
import PartDropZone from './PartDropZone';
import PartImageUploadHelp from './PartImageUploadHelp';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      uploadThumb1: null,
      uploadThumb2: null,
  	}
  }

  componentDidMount() {
    document.title = '本人証明書の申請 - パートナーズ';
    window.scrollTo(0, 0);
  };



  async _imageLoad(type, file) {
    await imageResize(file, 1200).then((res) => {
      if (type === 'front') {
        this.setState({uploadThumb1:res.uri});
      }
      else if (type === 'rotate') {
        this.setState({uploadThumb2:res.uri});
      }
    }).catch((err) => {
      if (type === 'front') {
        this.setState({uploadThumb1:null});
      }
      else if (type === 'rotate') {
        this.setState({uploadThumb2:null});
      }
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  async _imageRotate(type, rotate) {
    if (type === 'front') {
      let file = this.state.uploadThumb1;
      await imageRotate(file, rotate).then((res) => {
        this.setState({uploadThumb1:res.uri});
      })
    }
    else if (type === 'rotate') {
      let file = this.state.uploadThumb2;
      await imageRotate(file, rotate).then((res) => {
        this.setState({uploadThumb2:res.uri});
      })
    }
  }

  _submit() {
    let imageBase64Arr = [this.state.uploadThumb1, this.state.uploadThumb2];
    this.props.myProofAddNext('person', imageBase64Arr, () => {
      window.gtag("event", 'proofPerson_add');
      this.props.history.push('/new/emailAttestationDirect/');
    });
  }



  render() {
    let proofSample = [
      {uri:hnUnten, name:'運転免許証'},
      {uri:hnHokensyou, name:'保険証'},
      {uri:hnPassport, name:'パスポート'},
      {uri:hnMynumber, name:'マイナンバー'},
    ];
    let proofChecklist = [
      'お名前', '生年月日', '有効期限', '発行元'
    ];

    let imgMaxSize;
    if ((window.innerWidth * 0.7) > 240) {
      imgMaxSize = 240;
    }
    else {
      imgMaxSize = (window.innerWidth * 0.7);
    }

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <h1 align='center'>
          本人証明の申請
        </h1>


        <h2 align='center'>
          <span className='i-b'>この証明書の中から</span>
          <span className='i-b'>１つ申請してください</span>
        </h2>


        <div style={{margin:'15px'}}>
          <div>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                textAlign:'center',
                alignItems:'center',
                justifyContent:'center',
                flexWrap: 'wrap',
              }}
            >
              {
                proofSample.map(
                  (value, index, arr) => {
                    return(
                      <div
                        key={index}
                        style={{maxWidth:'240px', minWidth:'85px', width:'30%', cursor:'pointer', margin:'3px',position:'relative', overflow:'hidden'}}
                        onClick={ () => this.props.lightboxOpen(arr.map( (value, index) => {return {src:arr[index].uri, comment:'[' + arr[index].name + '] 赤枠以外は伏せていただいても問題ございません'}} ), index) }
                        className='round12'
                      >
                        <img
                          src={value.uri}
                          style={{width:'100%', height:'auto'}}
                          alt=''
                        />
                        <div
                          style={{
                            position:'absolute',
                            top:0,
                            left:0,
                            height:"100%",
                            width: "100%",
                            display: 'flex',
                            justifyContent:'center',
                            alignItems:'center',
                            backgroundColor:'rgba(0, 0, 0, 0.5)'
                          }}
                        >
                          <div style={{color:'#FFFFFF', fontWeight:'bold', textShadow:'0px 1px 3px #000'}}>{value.name}</div>
                        </div>
                        <ZoomInIcon
                          style={{
                            position: 'absolute',
                            top:'1px',
                            right:'1px',
                            fontSize:'2em',
                            color:'#fff',
                          }}
                        />
                      </div>
                    )
                  }
                )
              }
            </div>

            <Box style={{padding:'10px'}}>
              <div style={{margin:'10px'}}>
                <h3>
                  必要な情報
                </h3>
                {
                  proofChecklist.map(
                    (value, index, arr) => {
                      return(
                        <span
                          className='red_icon'
                          key={index}
                          style={{fontSize:'0.9em'}}
                        >
                          {value}
                        </span>
                      )
                    }
                  )
                }
                <div style={{color:'#666',fontSize:'0.9em'}}>
                  赤枠以外の情報は隠していただいて構いません。
                </div>
              </div>

              <div style={{margin:'10px'}}>
                <h3>
                  必要な画像
                </h3>
                <ul style={{marginLeft:'20px',color:'#666'}}>
                  <li style={{fontSize:'0.9em'}}>
                    <u className='link' onClick={ () => this.props.guideProofPersonSet(true) }>
                      証明書を正面から撮影した画像と、少し傾けて撮影した画像
                    </u>
                    の２枚の画像を申請してください。
                  </li>
                </ul>

              </div>

              <div style={{margin:'10px'}}>
                <h3>
                  個人情報の取り扱い
                </h3>
                <ul style={{marginLeft:'20px',color:'#666'}}>
                  <li style={{fontSize:'0.9em'}}>
                    証明書データはサポートに送信され一切公開されません。
                  </li>
                  <li style={{fontSize:'0.9em'}}>
                    日本プライバシー認証機構が発行する
                    <span
                      style={{color:'red'}}
                    >
                      TRUSTeマーク
                    </span>
                    を取得しています。
                  </li>
                </ul>
              </div>
            </Box>

          </div>
        </div>




        <Box boxShadow={2} style={{background:'#FFF',padding:'10px'}}>

          <h2 align='center'>証明書の画像をアップロード</h2>
          <div style={{margin:'20px 15px'}}>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                }}
              >
                <h4>
                  ステップ①  正面から撮影
                </h4>
                {
                  (this.state.uploadThumb1) ?
                  (<CheckIcon style={{color:'#75AC00'}} />) :
                  ''
                }
              </div>
              <div>
                  {
                    (!this.state.uploadThumb1) ? (
                      <PartDropZone
                        handleDrop={ (e) => this._imageLoad('front', e) }
                        style={{position:'relative'}}
                      >
                          <div>
                            <div align='center' style={{padding:'10px'}}>
                              <label htmlFor="photo_file" style={{display:'block'}}>
                                <div style={{padding:'10px'}}>
                                  <img
                                    src={hnUnten}
                                    style={{width:'90%', maxWidth:'240px', height:'auto'}}
                                    alt=""
                                  />
                                  <div align='center' style={{color:'red'}}>
                                    証明書を正面から画像を撮影してください
                                  </div>
                                </div>
                              </label>

                              <label htmlFor="front" style={{cursor:"pointer", display:'block'}}>
                                <Button variant="contained" color='primary' component="span">
                                  <div>
                                    <span style={{fontSize:'1.2em'}}>ファイルを選択する</span>

                                  </div>
                                </Button>
                              </label>

                              <input
                                type='file'
                                id='front'
                                accept='image/*'
                                onChange={ (e) => {
                                  this._imageLoad('front', e.target.files[0]);
                                  e.target.value = null;
                                }}
                                style={{opacity:'0'}}
                              />
                            </div>
                          </div>
                      </PartDropZone>
                    ): (
                      <>
                        <div style={{padding:'15px'}}>
                          <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
                            <div align='center' style={{padding:'5px', position:'relative'}}>
                              <img style={{ width:imgMaxSize, height:imgMaxSize, objectFit:'contain' }} src={this.state.uploadThumb1} alt="" id='thumb' />
                              <IconButton
                                style={{position:'absolute', right:'0px', top:'0px'}}
                                onClick={ () => this.setState({uploadThumb1: null}) }
                              >
                                <ClearIcon/>
                              </IconButton>
                            </div>
                          </div>

                          <div style={{textAlign:'center',}}>
                            <Fab
                              color='inherit'
                              size='small'
                              onClick={ () => this._imageRotate('front', 'l')}
                            >
                              <RotateLeftIcon/>
                            </Fab>
                            &nbsp;
                            <Fab
                              color='inherit'
                              size='small'
                              onClick={ () => this._imageRotate('front', 'r')}
                            >
                              <RotateRightIcon/>
                            </Fab>
                          </div>
                        </div>

                        <div
                          style={{
                            display:'flex',
                            flexDirection:'row',
                            alignItems:'center',
                          }}
                        >
                          <h4>
                            ステップ② 少し斜めから撮影
                          </h4>
                          {
                            (this.state.uploadThumb2) ?
                            (<CheckIcon style={{color:'#75AC00'}} />) :
                            ''
                          }
                        </div>

                        {
                          (!this.state.uploadThumb2) ? (
                            <PartDropZone
                              handleDrop={ (e) => this._imageLoad('rotate', e) }
                              style={{position:'relative'}}
                            >

                                <div>
                                  <div align='center' style={{padding:'10px'}}>
                                    <label htmlFor="photo_file" style={{display:'block'}}>
                                      <div style={{padding:'10px', transformStyle:'preserve-3d', perspective:'300px'}}>
                                        <img
                                          src={hnUntenRotate}
                                          style={{width:'90%', maxWidth:'240px', height:'auto'}}
                                          alt=""
                                        />
                                        <div align='center' style={{color:'red'}}>
                                          同じ証明書を少し斜めに傾かせて画像を撮影してください
                                        </div>
                                      </div>
                                    </label>

                                    <label htmlFor="rotate" style={{cursor:"pointer", display:'block'}}>
                                      <Button variant="contained" color='primary' component="span">
                                        <div>
                                          <span style={{fontSize:'1.2em'}}>ファイルを選択する</span>

                                        </div>
                                      </Button>
                                    </label>

                                    <input
                                      type='file'
                                      id='rotate'
                                      accept='image/*'
                                      onChange={ (e) => {
                                        this._imageLoad('rotate', e.target.files[0]);
                                        e.target.value = null;
                                      }}
                                      style={{opacity:'0'}}
                                    />
                                  </div>
                                </div>
                            </PartDropZone>

                          ): (
                            <div style={{padding:'15px'}}>
                              <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
                                <div align='center' style={{padding:'5px', position:'relative'}}>
                                  <img style={{ width:imgMaxSize, height:imgMaxSize, objectFit:'contain' }} src={this.state.uploadThumb2} alt="" id='thumb' />
                                  <IconButton
                                    style={{position:'absolute', right:'0px', top:'0px'}}
                                    onClick={ () => this.setState({uploadThumb2: null}) }
                                  >
                                    <ClearIcon/>
                                  </IconButton>
                                </div>
                              </div>

                              <div style={{textAlign:'center',}}>
                                <Fab
                                  color='inherit'
                                  size='small'
                                  onClick={ () => this._imageRotate('rotate', 'l')}
                                >
                                  <RotateLeftIcon/>
                                </Fab>
                                &nbsp;
                                <Fab
                                  color='inherit'
                                  size='small'
                                  onClick={ () => this._imageRotate('rotate', 'r')}
                                >
                                  <RotateRightIcon/>
                                </Fab>
                              </div>
                            </div>
                          )
                        }
                      </>
                    )
                  }

                  {
                    (this.state.uploadThumb1 && this.state.uploadThumb2) ? (
                      <div align='center' style={{padding:'10px'}}>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{minWidth:'200px'}}
                          onClick={ () => this._submit() }
                          startIcon={<CloudUploadIcon />}
                        >
                          <span style={{fontSize:'1.4em'}}>アップロード</span>
                        </Button>
                      </div>
                    ) : (null)
                  }

                  <div style={{padding:'5px'}} align='right'>
                    <PartImageUploadHelp />
                  </div>
              </div>

            </div>
        </Box>

        <div style={{paddingTop:'15px'}}>
          <h3 align='center'>TRUSTe認証を取得しています</h3>
          <div align='center'>
            <img
              src={ truste }
              alt=''
            />
          </div>
          <div  style={{padding:'10px'}}>
            「TRUSTe」マークは 日本プライバシー認証機構が 厳正な審査のもと付与されます。 <br />
            「パートナーズ」は、個人情報保護法よりも 高い基準で個人情報の利用や保護を 実施していることを意味します。
          </div>
        </div>


        <div align='right' style={{padding:'40px 10px 10px 0px'}}>
          <Button
            variant="outlined"
            onClick={ () => this.props.history.push('/new/emailAttestationDirect/') }
          >
            今は本人証明を登録しない
          </Button>
        </div>
      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myProofAction,
    ...lightboxAction,
    ...uiAction,
    ...guideAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withAlert()(Comp));
